// Strategic Compass — original geometric mark for Evony Strategist.
// Not derived from any official Evony asset. Easily replaceable.
export function CompassMark({ size = 32, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none"
      className={className} aria-hidden="true" role="img">
      <circle cx="24" cy="24" r="21" stroke="var(--gold)" strokeWidth="2" />
      <circle cx="24" cy="24" r="15" stroke="var(--border)" strokeWidth="1" />
      {/* Compass needle: N gold, S muted — forms a subtle 'S' pivot */}
      <path d="M24 6 L29 24 L24 42 L19 24 Z" fill="var(--gold)" opacity="0.95" />
      <path d="M24 42 L19 24 L24 24 Z" fill="var(--gold-muted)" />
      <path d="M6 24 L24 19 L42 24 L24 29 Z" fill="var(--surface-elevated)" stroke="var(--gold)" strokeWidth="1" opacity="0.9" />
      <circle cx="24" cy="24" r="3.2" fill="var(--bg-primary)" stroke="var(--gold)" strokeWidth="1.6" />
    </svg>
  );
}

export function Wordmark({ compact = false }) {
  return (
    <span className="es-wordmark" data-testid="brand-wordmark">
      <CompassMark size={compact ? 26 : 30} />
      {!compact && (
        <span className="es-wordmark-text">
          EVONY <span className="es-wordmark-accent">STRATEGIST</span>
        </span>
      )}
    </span>
  );
}
